module.exports = __webpack_public_path__ + "static/media/Slack-0.93bfaf52.jpg";